import React from "react";
import { useSelector } from "react-redux";
import { GoogleAnalyticsEnum, triggerFunction } from "../../utils/google-analytics";


// Instructor detail
const instructorName = process.env.REACT_APP_AUTHOR_NAME;
const instructorThumb = `${process.env.PUBLIC_URL}/images/instructor/${process.env.REACT_APP_AUTHOR_IMAGE}`;
const instructorLinkedIn = process.env.REACT_APP_AUTHOR_LINKEDIN_URL;
const instructorEmail = process.env.REACT_APP_AUTHOR_EMAIL;
const instructorYouTubeChannel = process.env.REACT_APP_YOUTUBE_CHANNEL_URL;

function AboutAuthor({ classes }) {

    // Reading store data
    const instructorData = useSelector(state => state.instructor.instructorData);

    // Constant variable 
    const data = instructorData && instructorData.length && instructorData.filter(instructor => instructor.id);

    return (
        <div>
            <div class={`edu-blog-widget  widget-about ${classes ? classes : ""}`}>
                <div class="inner">
                    <h5 class="widget-title">About Me</h5>
                    <div class="content">
                        <div class="about-wrapper">
                            <div class="thumbnail">
                                <img
                                    // src="https://1drv.ms/i/c/5add4c410fe50612/IQSDLDWIcNOzSJbuX9CMAhnkAQlxtsPp0oKSeE6KwEY5cSs"
                                    src={instructorThumb ? instructorThumb : ""}
                                    alt="Blog Images"
                                />
                            </div>
                            <div class="about-content">
                                <h6 class="title">{instructorName}</h6>
                                <p className="fs-15">
                                    Based in Surat, I’m a Salesforce and full-stack developer with
                                    9+ years of experience, specializing in Apex, Lightning Web
                                    Components, and system integrations. Beyond work, I enjoy
                                    Indian chai, cricket, reading, and quality time with my
                                    family.
                                </p>
                                <ul className="social-share bg-transparent justify-content-center medium-size">
                                    <li><a href={instructorLinkedIn} target="_blank" rel="noreferrer" onClick={() => triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_INSTRUCTOR_LINKEDIN_PROFILE_CLICKED)}><i className="icon-linkedin" ></i></a></li>
                                    <li><a href={`mailto:${instructorEmail}`} target="_blank" rel="noreferrer" onClick={() => triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_INSTRUCTOR_EMAIL_CLICKED)}><i className="icon-mail-line-2"></i></a></li>
                                    <li><a href={instructorYouTubeChannel} target="_blank" rel="noreferrer" onClick={() => triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LSA_INSTRUCTOR_YOUTUBE_CHANNEL_CLICKED)}><i className="icon-youtube" ></i></a></li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutAuthor;
